var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWasteMenagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1214_3211)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92337 31.6161L0.751808 24.4481C-0.00272097 23.1524 -0.281031 22.1319 0.346713 20.6322L2.79893 16.5132L0.34362 15.1927L8.57851 15.1587L12.6882 22.3391L10.1525 20.8826L6.03661 28.1774C5.64697 28.8701 5.32228 29.3927 5.12128 30.1813C5.00068 30.6575 4.94192 31.1368 4.92337 31.6161ZM6.57467 9.45337L10.539 2.55746C11.6554 1.169 13.0438 0.668046 14.3643 1.04222C15.5022 1.36382 15.8177 1.87715 16.4238 2.80176C17.1474 3.90572 17.7782 5.0839 18.4369 6.24043L14.0025 13.8568L6.57467 9.45337ZM15.595 0.0279331L23.8886 0.000102082C25.3884 -0.00608259 26.412 0.266043 27.3954 1.55864L29.7363 5.74257L32.1081 4.2768L28.0169 11.4201L19.7449 11.3892L22.2745 9.9234L18.0163 2.71208C17.6112 2.02867 17.3174 1.48442 16.7361 0.915433C16.3836 0.572184 16.0001 0.284597 15.595 0.0279331ZM33.6542 12.8766L37.6464 19.7601C38.2927 21.4207 38.0299 22.8741 37.0465 23.8296C36.1992 24.6553 35.5962 24.6707 34.4923 24.7326C33.1749 24.8068 31.839 24.7666 30.5062 24.7573L26.1275 17.11L33.6542 12.8766ZM37.3063 25.4005L33.1842 32.5964C32.4389 33.8983 31.6937 34.6497 30.0826 34.8538L25.2895 34.7889L25.373 37.5781L21.2292 30.4627L25.3915 23.3163L25.3977 26.2386L33.7717 26.1551C34.5665 26.1458 35.1819 26.1643 35.9673 25.9448C36.4404 25.8118 36.8826 25.6232 37.3063 25.4005ZM17.5958 34.7146L9.63918 34.7301C7.87964 34.458 6.75094 33.5055 6.41387 32.1758C6.12319 31.0286 6.40769 30.4998 6.90865 29.5133C7.50237 28.3352 8.20743 27.1972 8.88155 26.0499L17.6947 26.0808L17.5958 34.7146Z",
    fill: "#134046"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1214_3211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasteMenagementIcon);
export default __webpack_public_path__ + "static/media/waste_menagement_icon.24e1a89a580b3282c0f932a231505c4e.svg";
export { ForwardRef as ReactComponent };